import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9dad08f0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dad08f0')) {
      api.createRecord('9dad08f0', component.options)
    } else {
      api.reload('9dad08f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9dad08f0", function () {
      api.rerender('9dad08f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerQuotation/index.vue"
export default component.exports